var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2",attrs:{"small":"","color":_vm.getStatusName().color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.getStatusName().text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }